<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n'
import { to } from '~/routing';

import Link from '~/ui/Link.vue'

const props = defineProps<{ error?: { message: string } }>()

const { t } = useI18n()
const message = computed(() => props.error?.message.includes('401') ? t('sharelink.401') : undefined)
</script>

<template>
  <template v-if="message">
    <p>{{ message }}</p>
    <span>
      <Link v-bind="to({ name: 'login' })">
        {{ t('components.common.UserMenu.link.login') }}
      </Link> or <Link v-bind="to({ name: 'signup' })">
        {{ t('components.common.UserMenu.link.signup') }}
      </Link>
    </span>
  </template>
</template>
